var header4i = function() {
	var mn, header;
	
	// feature detect for passive event listener support
	// used in account/cart menu event listeners
	/*var supportsPassive = false;
	try {
  		var opts = Object.defineProperty({}, 'passive', {
    			get: function() {
      				supportsPassive = true;
    			}
  		});
  		window.addEventListener("testPassive", null, opts);
  		window.removeEventListener("testPassive", null, opts);
	} catch (e) {}*/
	 
	var ajaxActions = (function(){
		var callWrapper,
			userLinksWrapper,
		init = function(){
			callWrapper = document.getElementsByClassName("callWaitWrapper")[0];
			userLinksWrapper = document.getElementById("userSpecificLinksBox");
		},
		loadCallStats = function() {
			if (callWrapper == null) { return; }
			//work around to hide for now
			var callWaits = [].slice.call(document.querySelectorAll(".callWaitWrapper"));			
			callWaits.forEach(function(cw){
			    cw.classList.add("hide");
			    cw.classList.remove("hideOnMedium");			
			});
			
			//fetch('/Header/CallWaitTime', { headers: { 'X-Requested-With': 'fetch' }}).then(function(response ) {
			//	return  (response.ok) ? response.text() : ''; // response.text() returns a promise
			//}).then(function(html){
			//	if(html.length < 1) { return; }
			//	callWrapper.classList.add("hide");
	    		//	callWrapper.classList.remove("hideOnMedium");
	    		//	callWrapper.insertAdjacentHTML('afterend', html);
			//});
		},
		loadUserLinks = function() {
			if (userLinksWrapper == null) { return; }
			fetch('/Header/UserSpecificLinks', { headers: { 'X-Requested-With': 'fetch' }}).then(function(response){
				return  (response.ok) ? response.text() : ''; // response.text() returns a promise
			}).then(function(html){
				if(html.length < 1) { return; }
		    		userLinksWrapper.innerHTML = html;
				/*headerMobileSearch.Init();*/
				headerAccount.Init();
				headerCart.Init();
				if(document.getElementById('callBtn')){
					headerClickToCall.Init();
				}
				if(document.getElementById('seoBtn')){
					// bootload SEO bits here only when needed
					var seo = document.createElement('script'); 
					seo.type = 'text/javascript'; 
					seo.async = true; 
					seo.src = 'https://cdna.4imprint.ie/qtz/views/seooverlay/seoeditor.js';
					var bodyEl = document.getElementsByTagName('body')[0]; 
					bodyEl.appendChild(seo);
				}
			});
	    	};
		return{
			Init: init,
			LoadCallStats: loadCallStats,
			LoadUserLinks: loadUserLinks
		};
	})(),
	
    	adobe = (function () {
	    	var clickToCall = function (phNum) {
	     	 	if(s){
	      		      	s.linkTrackVars="prop20,eVar20,eVar33,events"; 
	 	      		s.linkTrackEvents="event28";
		      		s.events='event28';
	            		s.eVar33= phNum;
	            		s.prop20='D=v33';
	            		s.pe='lnk_o';
	            		s.pev2='Click-to-Call';
		        	s.tl(true, 'o', 'Click-to-Call');
		        	s.linkTrackEvents='None';
		        	s.linkTrackVars='None';
	        	}
	    	},
	    	pwaInstall = function(){
	         if(s){
	         	s.event30 = 'PWA Install';
	         	s.t();
	         }
	       }
	       
	    	return {
	        	ClickToCall: clickToCall,
	        	PwaInstall: pwaInstall
	    	};
	})(),
	
	headerClickToCall = (function(){
		var init = function(s, s_account){
    			document.getElementById('callBtn').addEventListener("click", function (e) {
            			e.preventDefault();
            			adobe.ClickToCall(this.getAttribute('data-adobe-v33'));
            			window.location.href=e.target.href;
       		});
		};
		return{
			Init: init
		};
	})(),
	
	/*headerMobileSearch = (function(){
		// wires up the magnifying glass icon in the menu to show or hide the search box on mobile.
		var mobileSearch,
			searchInput,
			searchBar,		
		init = function(){
			mobileSearch = document.getElementById("showMobileSearch");
			searchInput = document.getElementById("txtSearch");
			searchBar = document.getElementsByClassName("HeaderSearchBar")[0];
			if (mobileSearch !== null){
				mobileSearch.addEventListener("click", function(){				
					if(searchBar.classList.contains("show")){
						searchBar.classList.remove("show");
						searchBar.classList.add("hide");
						mobileSearch.classList.remove("bkgdLtGray");
						mobileSearch.setAttribute("aria-expanded", "false");
						mobileSearch.focus();
					}else{
						searchBar.classList.remove("hide");
						searchBar.classList.add("show");
						mobileSearch.classList.add("bkgdLtGray");
						mobileSearch.setAttribute("aria-expanded", "true");
						searchInput.focus();
					}
				});
			}	
		};
		return{
			Init: init
		};
	})(),*/
	
	headerAccount = (function(){
		var accountView,
			accountLink,
			
		init = function(){
			accountView = document.getElementById("accountMenu");
			accountLink = document.getElementById("lnkAccountSummary");		
			
			if(accountView){
				accountLink.removeEventListener("click", showHide);
				accountLink.addEventListener("click", showHide);
				accountKeys();
			}
		},
		show = function() {	
			if(accountView.classList.contains("animateFadeOut")){
				accountView.classList.remove("animateFadeOut");
				accountView.classList.add("animateFadeIn");
			}
			accountView.classList.remove("hide");
			accountLink.setAttribute("aria-expanded", "true");
			accountLink.querySelector(".accountTxt").querySelector("svg").removeAttribute("class");
			
			document.addEventListener("keydown", escapeAccount);
			document.addEventListener("click", closeClickOutside);
		},
		hide = function() {
			accountView.classList.remove("animateFadeIn");
			accountView.classList.add("animateFadeOut");
			accountLink.querySelector(".accountTxt").querySelector("svg").setAttribute("class", "rotate180");
			document.removeEventListener("keydown", escapeAccount);
			document.removeEventListener("click", closeClickOutside);
			accountLink.setAttribute("aria-expanded", "false");
			
			setTimeout(() => {
				accountView.classList.add("hide");
			}, 300);
		},
		showHide = function(e){
			e.preventDefault();
			if(accountView.classList.contains("hide")) show(); 
			else hide(); 
		},
		closeClickOutside = function(e){
			var specifiedElement = document.getElementById('accountTrigger');
			var isClickInside = specifiedElement.contains(e.target);
			
			if (!isClickInside) {
				hide();
			}
		},
		escapeAccount = function(e){
	    		if(e.keyCode === 27){ // allow user to close on escape
				hide();
				accountLink.focus();
	    		}
		},
		accountKeys = function(){
			if(accountView.querySelector("a") !== null){
				var accountDropLinks = [].slice.call(accountView.querySelectorAll("a"));
				var lastLink = accountDropLinks[accountDropLinks.length -1];
				lastLink.addEventListener("keydown", function(e){							
					if(e.keyCode == 9 && lastLink == document.activeElement){
			 			hide();
			 		}
				});
			}
		};
		return{
			Init: init
		};
	})(),
	
	headerCart = (function(){
		var cartView,
			cartSummary,
			checkoutLink,
			
		init = function(){
			cartView = document.getElementsByClassName("cartsummary_view")[0];
			cartSummary = document.getElementById("lnkCartSummary");
			checkoutLink = document.getElementById("checkoutLink");	
			
			if(cartView){ // not an empty cart
				cartSummary.removeEventListener("click", showHide);
				cartSummary.addEventListener("click", showHide);
				cartKeys();
			}
		},
		show = function() { 
			if(cartView.classList.contains("animateFadeOut")){
				cartView.classList.remove("animateFadeOut");
				cartView.classList.add("animateFadeIn");
			}
			cartView.classList.remove("hide");
			cartSummary.setAttribute("aria-expanded", "true");			
			document.addEventListener("keydown", escapeCart);
			document.addEventListener("click", closeClickOutside);
		},
		hide = function() {
			cartView.classList.remove("animateFadeIn");
			cartView.classList.add("animateFadeOut");
			cartSummary.setAttribute("aria-expanded", "false");
			document.removeEventListener("keydown", escapeCart);
			document.removeEventListener("click", closeClickOutside);
			
			setTimeout(() => {
				cartView.classList.add("hide");
			}, 300);
		},
		showHide = function(e){
			e.preventDefault();
			if(cartView.classList.contains("hide")) show(); 
			else hide(); 
		},
		closeClickOutside = function(e){
			var specifiedElement = document.querySelector('.cartsummary');
			var isClickInside = specifiedElement.contains(e.target);
			
			if (!isClickInside) {
				hide();
			}
		},
		escapeCart = function(e){
	    		if(e.keyCode === 27){ // allow user to close on escape
				hide();
				cartSummary.focus();
	    		}
		},
		cartKeys = function(){
			checkoutLink.addEventListener("keydown", function(e){							
				if(e.keyCode == 9 && checkoutLink == document.activeElement){
		 			hide();
		 		}
			});
		};
		return{
			Init: init
		};
	})(),
	stickyMenuBar = function(){
		if (window.scrollY > header.offsetHeight) {
			mn.classList.add("main-nav-scrolled");
		} else {
			mn.classList.remove("main-nav-scrolled");
		}
	},

	init = function(){
		mn = document.querySelector(".main-nav");
		header = document.querySelector('header');
		
		ajaxActions.Init();
		ajaxActions.LoadUserLinks();
		ajaxActions.LoadCallStats();
		window.addEventListener("scroll", stickyMenuBar);
		
		
		window.addEventListener('appinstalled', function() {
  			//do the logging
  			
		});				
	};
	
	return{
		Init: init,
		HeaderCart: headerCart
	};
};
(function(){
	var loadHeader = new header4i();
	loadHeader.Init();
})();